export const { EventBus, Events, store } = window.JiffyStore;
